<div>
    @if (!(this.sponsorInfoForm.get('email')?.value)) {
    <div class="form-floating mb-4">
        <input class="form-control px-4" id="civilId" type="number" autocomplete="off"
            placeholder="{{'CREATE_VISA.KUWAIT_RESIDENCE_INFO.CIVIL_ID_NO' | translate}}" appNumberOnly
            [max]="civilIdMaxLimit" [formControl]="civilIdControl" [pattern]="civilIDFormat" />
        <label>{{ "CREATE_VISA.KUWAIT_RESIDENCE_INFO.CIVIL_ID_NO" | translate }}</label>
        <app-validation-message [control]="civilIdControl"></app-validation-message>
    </div>
    }
</div>
@if(!this.sponsorInfoForm.get('civilId')?.value){
<button [disabled]="!civilIdControl.valid" type="button" (click)="onClickSendAuth()" class="btn-1 w-100 p-2 my-4">
    {{ "CREATE_VISA.AUTH_INIT_BUTTON" | translate }}
</button>
}
@if(this.sponsorInfoForm.get('civilId')?.value){
<app-email-verification [parentComponent]="parentComponent" [accountType]="accountType"
    (verifiedOTP)="onVerifyOTP($event)" />
}
<!-- captcha-->
@if(showCaptcha){
<app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
}

<div [hidden]="!(this.sponsorInfoForm.get('email')?.value)">
    <app-civil-id-info [civilIdInfoForm]="sponsorInfoForm" [isSubmitted]="isSubmitted"
        [parentComponent]="parentComponent" />
    <form [formGroup]="sponsorInfoForm">
        <div class="form-element mt-4">
            <div class="d-flex align-items-center">
                <input class="form-check-input m-2" id="termsService" type="checkbox"
                    (change)="termsAndConditionChange()" formControlName="termsAndCondition" />
                <p class="click-here text-2 my-2">
                    {{'SIGN_UP.I_ACCEPT' | translate}}

                    <span class="c-pointer ibm-medium"
                        (click)="openModal(componentsName.TERMS_AND_CONDITIONS)">{{'SIGN_UP.TERMS' |
                        translate}}</span>
                    {{'SIGN_UP.AND' | translate}}
                    <span class="c-pointer ibm-medium"
                        (click)="openModal(componentsName.PRIVACY_POLICY)">{{'SIGN_UP.PRIVACY_POLICY' |
                        translate}}</span>
                </p>
            </div>
            <app-validation-message [control]="sponsorInfoForm.get('termsAndCondition')"
                [formSubmission]="isSubmitted"></app-validation-message>
        </div>

    </form>
    <button [disabled]="!sponsorInfoForm.valid" (click)="onClickSignUp()" type="button" class="btn-1 w-100 p-2 my-4">
        {{ "AUTH.SIGN_UP_TITLE" | translate }}
    </button>
</div>